/**
 * Created by user on 2018/6/25/025.
 */


import Bluebird from "bluebird";
import NovelSite from "./src/site"

import requireNovelSiteClass from "./src/all"
export { NovelSite }
export default requireNovelSiteClass
export * from "./src/all"
